exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2ydvqWnH8RYLQP_3kB0G0k{margin-top:2.14286rem}.pvOPBwLkkJK7GKjrHXp1u{padding:1.42857rem 1.14286rem 1.28571rem 2.14286rem}._2vmYOnArE7jB3ehBKXz-Em{margin-top:2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PageActivitiesPart": "_2ydvqWnH8RYLQP_3kB0G0k",
	"PageActivitiesPart_container": "pvOPBwLkkJK7GKjrHXp1u",
	"PageActivitiesPart_container_view": "_2vmYOnArE7jB3ehBKXz-Em"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/CoveredInClass/PageActivitiesPart/style.postcss
// module id = 1540
// module chunks = 0